<div class="row page-header">
    <div class="col-12">
        <h1>Equipment Availability <small>See equipment location, utilization and availability</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (activeIdChange)="tabChanged()">
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Availability</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                                    <!--<action-toolbar-buttons [grid]="grid" [canEdit]="canEdit" [showAdd]="true" [showEdit]="true" [showDelete]="true"></action-toolbar-buttons>-->
                                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                                    <grid-export [grid]="mainGrid" [name]="'Equipment Utilization'"></grid-export>
                                    <button type="button" class="btn btn-sm btn-success" (click)="request()">Request Equipment</button>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <grid-column-group [grid]="grid"></grid-column-group>
                                <wj-flex-grid
                                    id="mainGrid"
                                    #mainGrid
                                    appAutoSize
                                    [frozenColumns]="3"
                                    (initialized)="grid.initialize(mainGrid); gridInitialized(mainGrid)"
                                    (destroy)="grid.destroy()"
                                    (cellEditEnded)="cellEditEnded(mainGrid, $event)"
                                    (pasting)="pasting(mainGrid, $event)"
                                    (pasted)="pasted(mainGrid, $event)"
                                    [itemsSource]="grid.view"
                                    [itemFormatter]="itemFormatter"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column
                                        [header]="'Id'"
                                        [binding]="'equipment'"
                                        [width]="100"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Available'"
                                        [binding]="'isAvailable'"
                                        [width]="100"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Description'"
                                        [binding]="'description'"
                                        [width]="'*'"
                                        [minWidth]="350"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Scheduled Until'"
                                        [binding]="'scheduledUsage'"
                                        [editor]="inputDate"
                                        [isRequired]="false"
                                        [width]="130"
                                    ></wj-flex-grid-column>
                                    <!--<wj-flex-grid-column [header]="'GPS Data'" [binding]="'hasGpsData'" [width]="90" [isReadOnly]="true"></wj-flex-grid-column>-->
                                    <wj-flex-grid-column
                                        [header]="'Work Orders'"
                                        [binding]="'workOrder'"
                                        [width]="100"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Non-RPO Rental'"
                                        [binding]="'isRental'"
                                        [width]="110"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Main Category'"
                                        [binding]="'mainCategory'"
                                        [width]="275"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Sub Category'"
                                        [binding]="'category'"
                                        [width]="275"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <!--<wj-flex-grid-column [header]="'Job (Vista)'" [binding]="'jobId'" [width]="120" [isReadOnly]="true"></wj-flex-grid-column>-->
                                    <wj-flex-grid-column
                                        [header]="'Job'"
                                        [binding]="'jobGpsId'"
                                        [dataMap]="jobMap"
                                        [width]="'*'"
                                        [minWidth]="350"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'GPS Past 7 Days'"
                                        [binding]="'utilizationGps'"
                                        [width]="100"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'GPS Year To Date'"
                                        [binding]="'utilizationGpsYtd'"
                                        [width]="100"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <!--<wj-flex-grid-column [header]="'Last GPS Reading'" [binding]="'lastGpsReading'" [format]="'MM/dd/yy H:mm:ss'" [width]="120" [isReadOnly]="true"></wj-flex-grid-column>-->
                                    <!--<wj-flex-grid-column [header]="'GPS Past 365 Days'" [binding]="'utilizationGpsPastYear'" [width]="100" [isReadOnly]="true"></wj-flex-grid-column>-->
                                    <wj-flex-grid-column
                                        [header]="'Project Manager'"
                                        [binding]="'projectManagerName'"
                                        [width]="150"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Super'"
                                        [binding]="'superName'"
                                        [width]="150"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <!--<wj-flex-grid-column [header]="'Unit'" [binding]="'unit'" [width]="180" [isReadOnly]="true"></wj-flex-grid-column>-->
                                    <wj-flex-grid-column
                                        [header]="'Category Code'"
                                        [binding]="'categoryCode'"
                                        [width]="120"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <wj-input-date #inputDate [isRequired]="false"></wj-input-date>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>Requests</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="requestGrid"></action-toolbar-count>
                                    <action-toolbar-buttons
                                        [grid]="requestGrid"
                                        [canEdit]="canEdit"
                                        [showAdd]="true"
                                        [showEdit]="true"
                                        [showDelete]="true"
                                    ></action-toolbar-buttons>
                                    <action-toolbar-search name="search" [(ngModel)]="requestGrid.filter"></action-toolbar-search>
                                    <grid-export [grid]="gridRequest" [name]="'Equipment Requests'"></grid-export>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-success"
                                        (click)="approveRequest()"
                                        [disabled]="!requestGrid.hasItemSelected"
                                    >
                                        Approve Request
                                    </button>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="gridRequest"
                                    #gridRequest
                                    appAutoSize
                                    (initialized)="requestGrid.initialize(gridRequest)"
                                    (destroy)="requestGrid.destroy()"
                                    [itemsSource]="requestGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column
                                        [header]="'Equipment'"
                                        [binding]="'equipment'"
                                        [dataMap]="equipmentMap"
                                        [width]="'*'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Images / Videos'"
                                        [binding]="'imageUrls'"
                                        [cssClass]="'cell-img'"
                                        [width]="100"
                                        [isReadOnly]="true"
                                    >
                                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                            <div *ngFor="let image of cell.item.imageUrls; let i = index">
                                                <img
                                                    [src]="'./Resources/Images/EquipmentRequest/' + image + '?w=500'"
                                                    *ngIf="image.indexOf('mp4') === -1"
                                                    (click)="openRequestImage(image)"
                                                />
                                                <video
                                                    *ngIf="image.indexOf('mp4') > -1"
                                                    style="width: 100%"
                                                    [src]="'./Resources/Images/EquipmentRequest/' + image"
                                                    (click)="openRequestImage(image)"
                                                ></video>
                                            </div>
                                        </ng-template>
                                    </wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Category'"
                                        [binding]="'category'"
                                        [dataMap]="equipmentMap"
                                        [width]="185"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'From Job'"
                                        [binding]="'fromJob'"
                                        [dataMap]="jobMap"
                                        [width]="'*'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'For Job'"
                                        [binding]="'forJob'"
                                        [dataMap]="jobMap"
                                        [width]="'*'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Requested By'"
                                        [binding]="'requestedByHrRef'"
                                        [dataMap]="allUserMap"
                                        [width]="160"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Date Needed'"
                                        [binding]="'dateNeeded'"
                                        [width]="160"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Notes'" [binding]="'notes'" [width]="400"></wj-flex-grid-column>
                                </wj-flex-grid>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="3" [destroyOnHide]="false">
            <a ngbNavLink>Transfers</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="transferGrid"></action-toolbar-count>
                                    <action-toolbar-buttons
                                        [grid]="transferGrid"
                                        [canEdit]="canEdit"
                                        [showAdd]="false"
                                        [showEdit]="true"
                                        [showDelete]="true"
                                    ></action-toolbar-buttons>
                                    <action-toolbar-search name="search" [(ngModel)]="transferGrid.filter"></action-toolbar-search>
                                    <grid-export [grid]="gridTransfer" [name]="'Equipment Transfers'"></grid-export>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-success"
                                        (click)="markTransferComplete()"
                                        [disabled]="
                                            !transferGrid.hasItemSelected ||
                                            (transferGrid.hasItemSelected && transferGrid.selectedItem.isComplete)
                                        "
                                    >
                                        Mark Complete
                                    </button>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="gridTransfer"
                                    #gridTransfer
                                    appAutoSize
                                    (initialized)="transferGrid.initialize(gridTransfer)"
                                    (destroy)="transferGrid.destroy()"
                                    [itemsSource]="transferGrid.view"
                                    [itemFormatter]="transferGridItemFormatter"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Complete'" [binding]="'isComplete'" [width]="115"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Equipment'"
                                        [binding]="'equipment'"
                                        [dataMap]="equipmentMap"
                                        [width]="300"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Images / Videos'"
                                        [binding]="'imageUrls'"
                                        [cssClass]="'cell-img'"
                                        [width]="100"
                                        [isReadOnly]="true"
                                    >
                                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                            <div *ngFor="let image of cell.item.imageUrls; let i = index">
                                                <img
                                                    [src]="'./Resources/Images/EquipmentTransfer/' + image + '?w=500'"
                                                    *ngIf="image.indexOf('mp4') === -1"
                                                    (click)="openTransferImage(image)"
                                                />
                                                <video
                                                    *ngIf="image.indexOf('mp4') > -1"
                                                    style="width: 100%"
                                                    [src]="'./Resources/Images/EquipmentTransfer/' + image"
                                                    (click)="openTransferImage(image)"
                                                ></video>
                                            </div>
                                        </ng-template>
                                    </wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'From Job'"
                                        [binding]="'fromJob'"
                                        [dataMap]="jobMap"
                                        [width]="300"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'For Job'"
                                        [binding]="'forJob'"
                                        [dataMap]="jobMap"
                                        [width]="300"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Need By Date'"
                                        [binding]="'transferDate'"
                                        [width]="110"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Requested By'"
                                        [binding]="'requestedByHrRef'"
                                        [dataMap]="allUserMap"
                                        [width]="160"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Transfer By'"
                                        [binding]="'transferByHrRef'"
                                        [dataMap]="allUserMap"
                                        [width]="160"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Transfer Completed Date'"
                                        [binding]="'completeDate'"
                                        [width]="110"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Notes'" [binding]="'notes'" [width]="400"></wj-flex-grid-column>
                                </wj-flex-grid>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="4" [destroyOnHide]="false" [hidden]="false">
            <a ngbNavLink>Breakdowns</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="breakdownGrid"></action-toolbar-count>
                                    <action-toolbar-buttons
                                        [grid]="breakdownGrid"
                                        [canEdit]="canEdit"
                                        [showAdd]="true"
                                        [showEdit]="true"
                                        [showDelete]="true"
                                    ></action-toolbar-buttons>
                                    <action-toolbar-search name="search" [(ngModel)]="breakdownGrid.filter"></action-toolbar-search>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-success"
                                        (click)="markBreakdownComplete()"
                                        [disabled]="
                                            !breakdownGrid.hasItemSelected ||
                                            (breakdownGrid.hasItemSelected && breakdownGrid.selectedItem.completedDate)
                                        "
                                    >
                                        Mark Complete
                                    </button>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="gridBreakdown"
                                    #gridBreakdown
                                    appAutoSize
                                    (initialized)="breakdownGrid.initialize(gridBreakdown)"
                                    (destroy)="breakdownGrid.destroy()"
                                    [itemsSource]="breakdownGrid.view"
                                    [itemFormatter]="breakdownGridItemFormatter"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column
                                        [header]="'Equipment'"
                                        [binding]="'equipment'"
                                        [dataMap]="equipmentMap"
                                        [width]="300"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Images / Videos'"
                                        [binding]="'imageUrls'"
                                        [cssClass]="'cell-img'"
                                        [width]="100"
                                        [isReadOnly]="true"
                                    >
                                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                            <div *ngFor="let image of cell.item.imageUrls; let i = index">
                                                <img
                                                    [src]="'./Resources/Images/EquipmentBreakdown/' + image + '?w=500'"
                                                    *ngIf="image.indexOf('mp4') === -1"
                                                    (click)="openImage(image)"
                                                />
                                                <video
                                                    *ngIf="image.indexOf('mp4') > -1"
                                                    style="width: 100%"
                                                    [src]="'./Resources/Images/EquipmentBreakdown/' + image"
                                                    (click)="openImage(image)"
                                                ></video>
                                            </div>
                                        </ng-template>
                                    </wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Occurrence Date'"
                                        [binding]="'date'"
                                        [width]="140"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Completed Date'"
                                        [binding]="'completedDate'"
                                        [width]="140"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Mechanic'"
                                        [binding]="'mechanicHrRef'"
                                        [dataMap]="allUserMap"
                                        [width]="180"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Work Order'"
                                        [binding]="'workOrder'"
                                        [width]="110"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Description'"
                                        [binding]="'description'"
                                        [width]="'*'"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>

<div id="popup" class="popover">
    <div class="popover-content">
        <div *ngFor="let order of popupOrders; let i = index">
            <hr *ngIf="i > 0" />
            <span
                >Work Order: <b>{{ order.workOrder }}</b></span
            >
            <span
                >Description: <b>{{ order.description }}</b></span
            >
            <span
                >Date Created: <b>{{ order.dateCreated | date: 'MMM d, y' }}</b></span
            >
            <span
                >Date Scheduled: <b>{{ order.dateSched | date: 'MMM d, y' }}</b></span
            >
            <span
                >Date Due: <b>{{ order.dateDue | date: 'MMM d, y' }}</b></span
            >
            <span
                >Mechanic: <b>{{ order.mechanic }}</b></span
            >
        </div>
    </div>
</div>
